const {generatedToolDemoPageDefinitions} = require("./GeneratedToolDemoPageCatalog.js")
const {isGeneratedToolDemoBlockedSlug} = require("./ToolDemoPageProtection.js")
const {isToolAvailable} = require("./ToolReleaseStatus.js")

const curatedToolDemoPageDefinitions = [
	{
		toolType: "aREQuestionnaire",
		slug: "a-r-e-questionnaire",
		title: "A.R.E. Questionnaire for Emotionally Focused Couples Therapy | Qwoach",
		metaDescription: "Explore the Accessibility, Responsiveness and Engagement questionnaire, private partner responses, and a side-by-side attachment bond review.",
		h1: "A.R.E. Questionnaire for Emotionally Focused Couples Therapy (EFCT)",
		intro: "The A.R.E. Questionnaire asks each partner how accessible, responsive, and engaged the other feels. Partners answer privately; practitioners review both reported perspectives together.",
		demoTitle: "Explore the A.R.E. Questionnaire",
		demoPrompt: "Answer the statements, compare partner perspectives, and adapt the questionnaire in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Private partner responses", body: "Each partner receives a separate link and answers the same questionnaire from their own viewpoint. The other partner's responses are not shown during completion."},
			{title: "Accessibility, Responsiveness, Engagement", body: "Review each partner's responses and complete section subtotals. The default True/False questionnaire sums one point for every True answer."},
			{title: "Adapt the template", body: "Practitioners can edit instructions, partners, sections, questions, response options, scoring, and review wording before sharing."},
		],
		faqItems: [
			{question: "What does the A.R.E. Questionnaire measure?", answer: "It organizes each partner's reported experience of accessibility, responsiveness, and emotional engagement in the relationship."},
			{question: "What happens if an answer is missing?", answer: "The partner's completed score and interpretation stay unavailable until every question has an answer."},
			{question: "Can I change the questionnaire?", answer: "Yes. The supplied version is an editable starting template. Adapted wording or scoring should be interpreted according to your configuration."},
			{question: "What is saved from this page?", answer: "Saving creates your reusable questionnaire configuration. The answers in this demo stay out of real client records."},
		],
	},
	{
		toolType: "featureMatchingAssessment",
		slug: "feature-matching-assessment",
		title: "AAC Feature-Matching Assessment | Qwoach",
		metaDescription: "Map documented AAC user needs and contexts to system-feature requirements, rationale, and dimension coverage.",
		h1: "AAC Feature-Matching Assessment for system requirements",
		intro: "Document communication, access, sensory, motor, and environmental needs, then link each AAC system-feature requirement to a need and explain why it matters.",
		demoTitle: "Build a feature requirements assessment",
		demoPrompt: "Add a documented need, link a required feature, and review the rationale and coverage.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Document needs", body: "Record abilities, contexts, and evidence gathered during assessment."},
			{title: "Explain feature requirements", body: "Link each required feature to the documented needs it supports and record the practitioner rationale."},
			{title: "Review coverage", body: "See which included dimensions have been considered, which needs remain unmatched, and which requirements need rationale. The tool does not recommend a device or assign a score."},
		],
		faqItems: [
			{question: "Does this assessment recommend a specific AAC device?", answer: "No. It organizes required system features and the reasoning behind them for later comparison or configuration."},
			{question: "Can I adapt the dimensions and questions?", answer: "Yes. Edit the reusable dimensions, grouping choices, instructions, questions, and review labels in settings."},
			{question: "What is saved from the demo?", answer: "Saving creates a reusable tool configuration. Needs, requirements, and rationale entered here stay out of real client records."},
		],
	},
	{
		toolType: "schemaTherapyCaseConceptualizationForm",
		slug: "schema-therapy-case-conceptualization-form",
		title: "Schema Therapy Case Conceptualization Form | Qwoach",
		metaDescription: "Draft and review an individual schema therapy case formulation covering needs, schemas, modes, coping, relationships, and treatment objectives.",
		h1: "Schema Therapy Case Conceptualization Form for Individual Cases",
		intro: "Organize a practitioner-authored schema therapy case formulation across presenting problems, developmental history, unmet needs, schemas, modes, coping, triggers, the therapy relationship, and treatment planning.",
		demoTitle: "Draft a case formulation",
		demoPrompt: "Review Mara Becker's formulation, revise entries, and adapt the reusable form in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "A connected formulation", body: "Record current problems, developmental origins, needs, schemas, modes, and coping patterns in one structured document."},
			{title: "Review unresolved areas", body: "See which sections and minimum entry counts still need attention. The tool does not generate clinical conclusions or evaluate certification quality."},
			{title: "Adapt the form", body: "Edit sections, questions, rating anchors, options, and completion thresholds for your practice."},
		],
		faqItems: [
			{question: "Who completes the form?", answer: "A practitioner records and revises the case formulation using information gathered in therapy or assessment."},
			{question: "Does it assign schemas or modes?", answer: "No. The practitioner identifies and interprets schemas, modes, origins, goals, and interventions."},
			{question: "What is saved from this page?", answer: "Saving creates a reusable form configuration. Entries made while exploring this page stay out of client records."},
		],
	},
	{
		toolType: "patientRulesForRitualPrevention",
		slug: "patient-rules-for-ritual-prevention",
		title: "Patient Rules for Ritual Prevention in OCD ERP | Qwoach",
		metaDescription: "Prepare an editable patient handout for ritual prevention during OCD exposure and response prevention, with washing, checking, and practitioner-defined rules.",
		h1: "Patient Rules for Ritual Prevention in OCD ERP",
		intro: "Prepare a focused handout for exposure and response prevention practice. Edit the ritual rules, specify the practice context, and share the same expectations for patient review.",
		demoTitle: "Review a ritual-prevention handout",
		demoPrompt: "Read the rules in the client view, then adapt the focus, wording, and practice context in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Set a clear practice frame", body: "Use the washing and checking rules as editable starting points. Choose the relevant focus and add any case-specific context or instructions before sharing."},
			{title: "Review together", body: "Patients can acknowledge reading the handout and send questions. The review preserves the rules used for that handout without scoring practice."},
			{title: "Adapt every section", body: "Rename, add, remove, and reorder rule sections, individual rules, and focus options to suit your practice."},
		],
		faqItems: [
			{question: "Can I change the rules?", answer: "Yes. All rules and focus options in the starting template can be edited before use."},
			{question: "Does the handout measure adherence?", answer: "No. It gives behavioral instructions and records review acknowledgement and patient questions when those are used."},
			{question: "What is saved from this page?", answer: "Saving creates a reusable configuration. The in-memory acknowledgement and questions do not become a client result."},
		],
	},
	{
		toolType: "wallQuestion",
		slug: "wall-question",
		title: "Wall Question Aphasia Life-Impact Rating | Qwoach",
		metaDescription: "Record how a person with aphasia rates its impact on life and compare their ratings across sessions.",
		h1: "Wall Question for Aphasia Life-Impact Rating",
		intro: "The Wall Question lets a person with aphasia show how much aphasia affects participation in life. Practitioners can revisit the same rating and review descriptive change over time.",
		demoTitle: "Record a Wall Question rating",
		demoPrompt: "Choose a line, view earlier ratings, or adapt the question and scale in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "The person's own judgment", body: "One pictographic rating captures the person's view of aphasia's impact. Support with communication does not replace their choice."},
			{title: "Review change over time", body: "See dated ratings and numeric change when the same scale and construct were used. The rating does not explain why a change happened."},
			{title: "Adapt the template", body: "Edit wording, positions, anchors, administration context, and completion mode for your practice."},
		],
		faqItems: [
			{question: "Who chooses the rating?", answer: "The person with aphasia chooses the line, with assistance when needed."},
			{question: "What if the person cannot complete it?", answer: "Record unable to complete. No score or change is inferred for that administration."},
			{question: "What is saved from this page?", answer: "Saving creates the reusable tool configuration. Ratings entered here remain separate from client records."},
		],
	},
	{
		toolType: "eftCaseFormulation",
		slug: "eft-case-formulation",
		title: "EFT Case Formulation Treatment Map | Qwoach",
		metaDescription: "Build an editable Emotion-Focused Therapy case formulation linking presenting issues, emotional processes, change targets, and session direction.",
		h1: "EFT Case Formulation Treatment Map",
		intro: "Organize presenting difficulties, emotional schemes and markers, priority change targets, and tentative therapeutic tasks in one revisable EFT treatment map.",
		demoTitle: "Build an EFT case formulation",
		demoPrompt: "Connect a presenting issue to an emotional process, mark what remains unresolved, and review the treatment direction.",
		workTabLabel: "Practitioner Map",
		workTabDescription: "Build the practitioner-authored formulation map.",
		resultTabDescription: "Review the formulation, unresolved questions, and revisions.",
		ctaText: "Save this tool",
		sections: [
			{title: "A provisional map", body: "Record presenting issues, clinical evidence, emotional schemes, markers, needs, and priority change targets. Leave uncertain links open for later sessions."},
			{title: "Plan the next session", body: "Review tentative tasks and session implications based on practitioner-entered observations. The tool does not choose tasks or score progress."},
			{title: "Adapt the template", body: "Edit stages, questions, labels, choices, and instructions to fit your practice."},
		],
		faqItems: [
			{question: "Can the formulation be incomplete?", answer: "Yes. Unanswered areas remain visible as gaps while the formulation develops."},
			{question: "Does the tool choose an EFT task?", answer: "No. The practitioner records possible tasks and interprets markers in the session."},
			{question: "What is saved from this page?", answer: "Saving creates the editable tool template. The current case material stays out of real client records."},
		],
	},
	{
		toolType: "subjectiveUnitsOfDistressScaleSuds",
		slug: "subjective-units-of-distress-scale-suds",
		title: "SUDS Rating for ERP and Exposure Therapy | Qwoach",
		metaDescription: "Record subjective distress during an exposure and review reported ratings, missed moments, peak, and observed change.",
		h1: "Subjective Units of Distress Scale (SUDS) for Exposure Therapy",
		intro: "SUDS records how distressed a client feels at a particular moment during exposure therapy or ERP. Repeated ratings show the observed pattern for one exposure target.",
		demoTitle: "Record SUDS during an exposure",
		demoPrompt: "Enter a rating, mark a missed moment, or adapt the scale and prompts in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Quick momentary ratings", body: "Use the configured scale to communicate current subjective distress before, during, or after an exposure."},
			{title: "Descriptive review", body: "See the observed ratings, peak, first and last recorded points, and gaps. The tool does not decide whether an exposure succeeded."},
			{title: "Adapt the template", body: "Practitioners can edit the question, scale, anchors, instructions, and rating moments before sharing."},
		],
		faqItems: [
			{question: "What does SUDS measure?", answer: "The client's subjective distress or anxiety at the moment they give a rating."},
			{question: "What happens when a moment is missed?", answer: "It remains a gap and does not become a zero rating."},
			{question: "What is saved from this page?", answer: "Saving creates the reusable configuration. Ratings entered here stay out of real client records."},
		],
	},
	{
		toolType: "deconstructionQuestions",
		slug: "deconstruction-questions",
		title: "Deconstruction Questions for Narrative Therapy | Qwoach",
		metaDescription: "Map a fixed belief or problem story to social, relational, cultural, historical, and power contexts with a narrative therapy tool.",
		h1: "Deconstruction Questions for Narrative Therapy",
		intro: "Explore how a belief or problem story relates to social, relational, cultural, historical, and power contexts, then name possible alternative positions.",
		demoTitle: "Explore a contextual meaning map",
		demoPrompt: "Revise the focus, add a context, mark a link tentative or rejected, and review the map.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Contextual links", body: "Record the client's wording and discuss how social, relational, cultural, historical, or power contexts may connect to it. Links can remain tentative or be rejected."},
			{title: "Alternative positions", body: "Name emerging values, preferences, or interpretations without deciding whether the original belief is true or false."},
			{title: "Adapt the map", body: "Practitioners can edit the areas, status choices, instructions, and their own conversation questions before sharing."},
		],
		faqItems: [
			{question: "Does the map decide whether a belief is true?", answer: "No. It organizes the contexts and alternatives entered during the conversation."},
			{question: "Can a link remain uncertain?", answer: "Yes. Mark it tentative or rejected when it does not fit the client's understanding."},
			{question: "What is saved from this page?", answer: "Saving creates a reusable tool configuration. The words entered while exploring this page are not saved as a client response."},
		],
	},
	{
		toolType: "patientExRpAdherenceScalePeas",
		slug: "patient-ex-rp-adherence-scale-peas",
		title: "Patient EX/RP Adherence Scale (PEAS) for ERP Homework | Qwoach",
		metaDescription: "Rate ERP homework adherence with three clinician-rated PEAS items, a session mean, and dated trends.",
		h1: "Patient EX/RP Adherence Scale (PEAS) for ERP Homework Review",
		intro: "Review assigned exposure and response prevention homework, enter clinician ratings, and compare adherence across sessions.",
		demoTitle: "Rate ERP homework adherence",
		demoPrompt: "Review the homework context, enter the three ratings, and inspect the session mean and earlier sessions.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Three adherence domains", body: "Rate the proportion of exposures attempted, the quality of attempted exposures, and resistance to ritualizing since the last visit."},
			{title: "Session and treatment trends", body: "A complete session mean uses the configured required ratings. Dated earlier sessions remain visible, including incomplete sessions."},
			{title: "Adapt your template", body: "Edit instructions, questions, rating anchors, nonrating choices, and scoring participation before using the scale in your practice."},
		],
		faqItems: [
			{question: "Who completes the ratings?", answer: "The practitioner rates adherence using homework logs, client report, and clinical judgment."},
			{question: "What if a rating is missing?", answer: "The session remains visible, but it has no complete mean until every required rating is numeric."},
			{question: "What is saved from the demo?", answer: "Saving creates the reusable template and its settings. The current in-memory ratings and homework details are not saved as client data."},
		],
	},
	{
		toolType: "imaginalExposureScriptWorksheet",
		slug: "imaginal-exposure-script-worksheet",
		title: "Imaginal Exposure Script Worksheet for OCD ERP | Qwoach",
		metaDescription: "Create a first-person feared-outcome script for OCD ERP with clear response-prevention rules and a repeatable practice mode.",
		h1: "Imaginal Exposure Script Worksheet for OCD ERP",
		intro: "Build a first-person feared-outcome narrative with a client when an OCD fear cannot be approached in vivo. Keep the script, response-prevention rules, and practice mode together.",
		demoTitle: "Draft an imaginal exposure script",
		demoPrompt: "Edit the feared outcome and script, review readiness, then adapt the reusable template in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "One feared outcome", body: "The worksheet centers on a specific feared consequence and a vivid first-person, present-tense narrative that can be used repeatedly."},
			{title: "Response prevention", body: "Name the checking, reassurance seeking, avoidance, or mental neutralizing responses to refrain from during practice."},
			{title: "Review and revise", body: "A completeness check shows whether the target, script, and rules are present. The practitioner decides whether the content is clinically useful."},
		],
		faqItems: [
			{question: "What makes the script ready?", answer: "The target feared outcome, narrative, and response-prevention rules must be present. Readiness does not score distress or predict treatment response."},
			{question: "Can I change the delivery mode?", answer: "Yes. The same script can be prepared for reading aloud, visualization, recording, listening, or a combination."},
			{question: "What is saved from the demo?", answer: "Saving creates the reusable template and its settings. The in-memory feared outcome, script, and practitioner notes are not saved as client data."},
		],
	},
	{
		toolType: "momentaryTimeSampling",
		slug: "momentary-time-sampling",
		title: "Momentary Time Sampling for ABA Observation | Qwoach",
		metaDescription: "Set predetermined sampling moments, score behavior only at each exact moment, and review a sampled occurrence estimate with missed prompts kept separate.",
		h1: "Momentary Time Sampling for ABA behavior observation",
		intro: "Momentary time sampling estimates behavior occurrence from scores recorded at predetermined moments. Set a schedule, score whether the target behavior is occurring at each prompt, and review the sampled percentage.",
		demoTitle: "Run a timed sampling session",
		demoPrompt: "Start the short schedule, score a prompt, and review the estimate. Adjust the reusable schedule in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Exact-moment scoring", body: "Record present only when the behavior is occurring at the scheduled moment. Activity before or after that moment does not count."},
			{title: "Missed prompts", body: "Missed moments remain separate from not-present scores. The estimate divides present scores by valid scores and shows coverage of the planned schedule."},
			{title: "Repeat observations", body: "Keep the schedule and context with each result. Compare later estimates descriptively when those conditions are similar."},
		],
		faqItems: [
			{question: "What does the recorder score?", answer: "Whether the target behavior is occurring at the exact predetermined moment."},
			{question: "Does a missed prompt mean not present?", answer: "No. Missed prompts are tracked separately and do not enter the occurrence denominator."},
			{question: "Does this count behavior between prompts?", answer: "No. The result is a sampled estimate, not an exact count or duration."},
			{question: "What is saved from this page?", answer: "The reusable tool configuration is saved. In-memory scores and missed prompts stay out of client records."},
		],
	},
	{
		toolType: "importanceRuler",
		slug: "importance-ruler",
		title: "Importance Ruler for Motivational Interviewing | Qwoach",
		metaDescription: "Capture how important one change is to a client, the personal reasons behind it, and same-focus importance changes over time.",
		h1: "Importance Ruler for Client Change Talk",
		intro: "An Importance Ruler helps a client rate how much one possible change matters and explain the personal reasons behind that rating.",
		demoTitle: "Explore the importance of one change",
		demoPrompt: "Choose an importance rating, add your reasons, and adapt the reusable ruler in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Importance and meaning", body: "The client chooses a discrete importance rating and explains why the change matters or does not matter. Both answers support the practitioner's conversation."},
			{title: "Review over time", body: "Completed ratings can be compared with earlier importance responses for the same change focus. The tool does not infer a motivation level or score the client's words."},
			{title: "Adapt the ruler", body: "Practitioners can edit the change focus, questions, instructions, scale, and anchors before sharing."},
		],
		faqItems: [
			{question: "How is this different from a Readiness Ruler?", answer: "This ruler measures how important a change feels. Readiness and confidence are separate questions."},
			{question: "Are personal reasons required?", answer: "The default template asks for both a rating and the client's own reasons. Practitioners can adapt the completion rules."},
			{question: "Can importance be tracked over time?", answer: "Yes. Earlier completed ratings are shown when they concern the same change focus."},
		],
	},
	{
		toolType: "cciGradedTasksAndGradedExposureWorksheet",
		slug: "cci-graded-tasks-and-graded-exposure-worksheet",
		title: "Graded Tasks and Graded Exposure Worksheet | Qwoach",
		metaDescription: "Build a graded task or exposure ladder with one goal, ordered steps, and optional 0–100 distress ratings.",
		h1: "Graded Tasks and Graded Exposure Worksheet for CBT planning",
		intro: "Break a difficult goal into manageable steps. Order the steps from easier to harder and record distress ratings when they help you plan.",
		demoTitle: "Build a graded ladder",
		demoPrompt: "Edit the ladder, review its order, and adapt the template in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "One goal, gradual steps", body: "Name a goal and put smaller steps in the order you plan to try them. The first step remains visible as the plan progresses."},
			{title: "Optional distress ratings", body: "Reported ratings help compare steps. The ladder keeps the order you choose and does not prescribe a clinical next step."},
			{title: "Adapt the template", body: "Practitioners can edit instructions, prompts, labels, framing, and the rating scale for their practice."},
		],
		faqItems: [
			{question: "Can I use this for graded tasks and exposure?", answer: "Yes. Choose the planning frame in settings and build the same kind of ordered ladder."},
			{question: "Are distress ratings required?", answer: "No. You can leave a rating unanswered or turn ratings off for the template."},
		],
	},
	{
		toolType: "ocairs",
		slug: "ocairs",
		title: "OCAIRS Occupational Adaptation Profile | Qwoach",
		metaDescription: "Explore a practitioner-led OCAIRS interview and a structured occupational adaptation profile across twelve editable assessment areas.",
		h1: "OCAIRS occupational adaptation assessment",
		intro: "OCAIRS helps occupational therapy practitioners organize interview information, observations, and area ratings into a dated occupational participation profile.",
		demoTitle: "Record an occupational participation assessment",
		demoPrompt: "Review the profile and adapt the assessment template in settings.",
		workTabLabel: "Practitioner assessment",
		workTabDescription: "Record reported information, observations, source limitations, interpretation and supported area ratings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Twelve assessment areas", body: "The starting template covers roles, habits, motivation, skills, goals, past experience, environments, and readiness for change. Practitioners can adapt the structure and wording."},
			{title: "Distinct information sources", body: "Client report, practitioner observation, source limitations and practitioner interpretation stay separate in the profile."},
			{title: "Dated follow-up", body: "A later assessment can show earlier entered ratings and context, with gaps and structural differences visible."},
		],
		faqItems: [
			{question: "Who records the assessment?", answer: "A practitioner administers the interview and records the profile."},
			{question: "Does the profile have a total score?", answer: "The starting template shows individual area ratings and a written interpretation. It does not calculate a total."},
			{question: "Can the assessment be adapted?", answer: "Yes. Practitioners can edit areas, wording, rating choices, and review labels before using a template."},
		],
	},
	{
		toolType: "mohost",
		slug: "mohost",
		title: "MOHOST Occupational Participation Screening | Qwoach",
		metaDescription: "Complete a MOHOST occupational participation screening profile, review strengths and limitations, and compare later assessments.",
		h1: "MOHOST Occupational Participation Screening",
		intro: "MOHOST helps occupational therapy practitioners organize 24 participation ratings across six areas. Record observations and context, then review a structured profile without a default total score.",
		demoTitle: "Record an occupational participation assessment",
		demoPrompt: "Review the ratings, add context, and adapt the assessment template in settings.",
		workTabLabel: "Practitioner assessment",
		workTabDescription: "Enter ratings, comments, context, and a strengths and limitations analysis.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Structured screening", body: "The profile groups professional judgments across motivation, patterns, communication, process, motor skills, and environment. Unrated items remain visible."},
			{title: "Review over time", body: "Repeat the assessment in a new context or at a later date. Matching item meanings can be compared without combining ratings into a default total."},
			{title: "Adapt the template", body: "Practitioners can edit instructions, sections, items, rating choices, and completion rules. Interpret adaptations in their own context."},
		],
		faqItems: [
			{question: "Who completes MOHOST in Qwoach?", answer: "An occupational therapy practitioner records the assessment. Clients may be observed or interviewed as part of practice."},
			{question: "Does MOHOST produce a total score?", answer: "The default profile shows ordinal item ratings and a practitioner-written analysis. It does not calculate a total."},
			{question: "Can assessments be compared?", answer: "Yes. Earlier completed assessments remain separate, with item comparisons when meanings match."},
		],
	},
	{
		toolType: "happinessScale",
		slug: "happiness-scale",
		title: "Happiness Scale for Community Reinforcement Approach (CRA) | Qwoach",
		metaDescription: "Explore the CRA Happiness Scale to review happiness across ten life areas and compare later ratings.",
		h1: "Happiness Scale for Community Reinforcement Approach treatment planning",
		intro: "Rate happiness across life areas today. Review lower reported areas and repeat the scale to see descriptive changes over time.",
		demoTitle: "Rate life areas and review the profile",
		demoPrompt: "Change a rating, review the profile, and adapt the reusable scale in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Today's profile", body: "Ten independent ratings show where happiness is higher or lower today. Unanswered areas stay visible until the profile is complete."},
			{title: "Repeat to monitor change", body: "Compare earlier and current ratings using the latest area labels and format. History matches areas by their stable identifiers and preserves the ratings originally recorded."},
			{title: "Adapt the template", body: "Practitioners can edit instructions, the question, area labels and order, anchors, scale, and an optional sum. Adapted templates should be interpreted in their own context."},
		],
		faqItems: [
			{question: "What does the Happiness Scale show?", answer: "It shows reported happiness for each life area. Lower values describe lower happiness in that area; the scale does not generate a treatment plan."},
			{question: "Does it have a required total score?", answer: "No. The default review shows area ratings. A practitioner may explicitly configure a sum for an adapted template."},
			{question: "Can the scale be customized?", answer: "Yes. A practitioner can edit the reusable structure before assigning it. Comparisons are shown only when area meanings and the rating scale match."},
		],
	},
	{
		toolType: "iptTimeline",
		slug: "ipt-timeline",
		title: "IPT Timeline for Interpersonal Events and Symptoms | Qwoach",
		metaDescription: "Build an interpersonal psychotherapy timeline of events, role transitions, and symptom changes with exact, approximate, or relative timing.",
		h1: "Interpersonal Psychotherapy (IPT) Timeline for events and symptom changes",
		intro: "Use an Interpersonal Psychotherapy (IPT) timeline to place interpersonal events, role transitions, and symptom changes in chronological order. Review reported timing and record a practitioner-authored treatment hypothesis.",
		demoTitle: "Build and review an IPT timeline",
		demoPrompt: "Add an event, adjust its reported timing, then review the chronology and adapt the template.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Reconstruct timing together", body: "Client and practitioner add relevant events and symptom changes. Exact dates, approximate periods, and relative order remain clearly distinguished."},
			{title: "Review the sequence", body: "The chronology shows reported timing, notes, and unresolved entries. A practitioner can add a private hypothesis after review."},
			{title: "Adapt the template", body: "Edit questions, categories, timing choices, and marker styles before sharing with a client."},
		],
		faqItems: [
			{question: "Are exact dates required?", answer: "No. Approximate periods and relative order can be recorded."},
			{question: "Does the timeline infer causality?", answer: "No. It displays the reported sequence; interpretation remains with the practitioner."},
			{question: "Can a partial timeline be saved?", answer: "Yes. Uncertain and incomplete entries can remain in the chronology for later review."},
		],
	},
	{
		toolType: "youngSchemaQuestionnaireLongForm3rdEditionYsqL3",
		slug: "young-schema-questionnaire-long-form-3rd-edition-ysq-l3",
		title: "Young Schema Questionnaire Long Form (YSQ-L3) | Qwoach",
		metaDescription: "Explore the 232-item Young Schema Questionnaire with editable 1–6 ratings and an 18-schema score profile.",
		h1: "Young Schema Questionnaire Long Form (YSQ-L3) for schema therapy assessment",
		intro: "The Young Schema Questionnaire Long Form asks clients to rate 232 statements. Practitioners review scores across 18 early maladaptive schemas alongside clinical information.",
		demoTitle: "Rate statements and review schema scores",
		demoPrompt: "Complete ratings, review scores and categories, then adapt the assessment in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Comprehensive assessment", body: "The questionnaire covers 18 early maladaptive schemas with a one-to-six response scale."},
			{title: "Scored profile", body: "Ratings of four and above contribute to schema sums. The report shows each score with its maximum and descriptive grid category."},
			{title: "Adapt the template", body: "Practitioners can edit wording, response choices, scoring rules, and interpretation bands. Adapted templates are identified in the result."},
		],
		faqItems: [
			{question: "Can I adjust the questionnaire?", answer: "Yes. The default contains the long-form questionnaire; practitioners can adapt its questions, scale, scoring and profile categories."},
			{question: "What happens if a rating is missing?", answer: "The client can resume the draft. The final score profile requires every configured statement to be rated."},
			{question: "Does the score select treatment targets?", answer: "No. The profile is descriptive; the practitioner interprets it alongside other clinical information."},
		],
	},
	{
		toolType: "schemaModeInventorySmi11ShortSmi",
		slug: "schema-mode-inventory-smi-1-1-short-smi",
		title: "Schema Mode Inventory Adult Short SMI Demo | Qwoach",
		metaDescription: "Preview the adult 118-item short Schema Mode Inventory with frequency ratings, editable mode scoring, and a 14-mode profile.",
		h1: "Schema Mode Inventory (adult short SMI) for schema therapy",
		intro: "The adult 118-item short Schema Mode Inventory asks how often mode-related statements describe a client. Practitioners review separate mode means to support formulation and monitor change.",
		demoTitle: "Rate statements and review schema modes",
		demoPrompt: "Adjust ratings, inspect the mode profile, and adapt the questionnaire in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Adult short form", body: "This preset uses the 118-item adult short SMI and its version 1 scoring key. The separately labeled SMI version 1.1 has 124 items and uses different numbering."},
			{title: "Mode profile", body: "The report presents individual mode scores and descriptive groups. Higher means reflect more frequent reported manifestations; practitioner interpretation guides care."},
			{title: "Adapt and monitor", body: "Practitioners can edit wording, ratings, and mode assignments. Adapted templates are labeled as such, and dated administrations can be viewed together."},
		],
		faqItems: [
			{question: "Does this inventory diagnose a condition?", answer: "No. It presents reported schema mode frequencies for practitioner interpretation."},
			{question: "Can the questionnaire be adapted?", answer: "Yes. Practitioners can edit the template; adaptations are identified separately from the 118-item source preset."},
			{question: "Are demo ratings saved as client data?", answer: "No. Saving keeps the configured template only."},
		],
	},
	{
		toolType: "interpersonalInventory",
		slug: "interpersonal-inventory",
		title: "Interpersonal Inventory for IPT Assessment | Qwoach",
		metaDescription: "Map significant relationships, support, strain, interpersonal stressors, and presenting-problem links during interpersonal psychotherapy assessment.",
		h1: "Interpersonal Inventory for interpersonal psychotherapy assessment",
		intro: "Interpersonal Inventory helps practitioners record important relationships, distinguish support and strain, and review how relationship context may connect to the presenting problem.",
		demoTitle: "Map the client's relationships",
		demoPrompt: "Explore the inventory, review the relationship context, and adapt the assessment questions in settings.",
		workTabLabel: "Practitioner inventory",
		workTabDescription: "Record relationships during assessment and leave uncertain links open.",
		resultTabDescription: "Review support, strain, client-reported context, and practitioner formulation notes.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Relationship context", body: "Place important current or past relationships by closeness. A person may be both supportive and stressful."},
			{title: "Clinical review", body: "Review reported context and possible links to the presenting problem. The practitioner writes the formulation and chooses the treatment focus."},
			{title: "Adapt the inventory", body: "Edit closeness levels, support and strain options, relationship questions, and instructions for your practice."},
		],
		faqItems: [
			{question: "Can a relationship be both supportive and stressful?", answer: "Yes. Both characterizations can be recorded for the same person."},
			{question: "Does it choose an IPT treatment focus?", answer: "No. The inventory organizes assessment information for the practitioner's formulation."},
		],
	},
	{
		toolType: "gradedTaskAssignment",
		slug: "graded-task-assignment",
		title: "Graded Task Assignment Worksheet for CBT Practice | Qwoach",
		metaDescription: "Use a CBT graded task worksheet to break an overwhelming non-fear-based goal into small, achievable actions.",
		h1: "Graded Task Assignment for achievable steps",
		intro: "Build an ordered path from one large goal to a first action you can take now. Review progress and make a step smaller when needed.",
		demoTitle: "Build a graded action plan",
		demoPrompt: "Adjust the steps and review the next achievable action.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Start with the current step", body: "Name a larger non-fear-based goal, then make the first action small enough to begin now. Later actions can remain provisional."},
			{title: "Adjust the sequence", body: "Move actions into a gradual order, record what happened, and split a step when it feels too large."},
			{title: "Use with clients", body: "Practitioners can edit the worksheet wording and guidance before sharing it. Client plans and notes stay separate from the reusable template."},
		],
		faqItems: [
			{question: "Can a client start with one step?", answer: "Yes. A goal and one concrete first action can be ready to use while later steps remain provisional."},
			{question: "Does it use exposure ratings?", answer: "No. The plan supports non-fear-based goals and records progress without numerical ratings or scores."},
		],
	},
	{
		toolType: "systematicEvocativeUnfolding",
		slug: "systematic-evocative-unfolding",
		title: "Systematic Evocative Unfolding for Emotion-Focused Therapy (EFT) | Qwoach",
		metaDescription: "Explore a live-session Emotion-Focused Therapy (EFT) episode map for a puzzling emotional reaction, emerging meanings, and practitioner review.",
		h1: "Systematic Evocative Unfolding for emotional reaction episodes",
		intro: "Systematic Evocative Unfolding helps an Emotion-Focused Therapy (EFT) practitioner and client revisit one puzzling reaction. Record the particular situation, what was noticed and felt, and meanings that emerge without forcing a complete sequence.",
		demoTitle: "Explore an episode unfolding",
		demoPrompt: "Add what emerged in the meeting, leave uncertain elements open, and review the sequence.",
		ctaText: "Save and get shareable link",
		workTabLabel: "Client view",
		workTabDescription: "Record one particular moment together. The practitioner adds observations and possible targets during review.",
		resultTabDescription: "Review the reported sequence, unknown elements, and separate practitioner observations and targets.",
		sections: [
			{title: "One moment at a time", body: "Begin with a particular situation and the reaction that felt confusing. Add process details as they arise, even when the order of recall changes."},
			{title: "Partial maps are useful", body: "Unsupported elements remain unknown. A meaning may emerge without a broader pattern or a new response becoming clear."},
			{title: "Adapt the template", body: "Practitioners can edit the questions, process categories, choices, and review headings before sharing."},
		],
		faqItems: [
			{question: "Does the map generate a clinical formulation?", answer: "No. It organizes entered material and keeps practitioner interpretations separate."},
			{question: "Does every process element need an answer?", answer: "No. Unknown elements stay visible, and an anchored partial episode can be reviewed."},
			{question: "Can I change the process categories?", answer: "Yes. Edit, add, remove, or reorder categories in practitioner settings."},
		],
	},
	{
		toolType: "patternsOfProblematicThinkingWorksheet",
		slug: "patterns-of-problematic-thinking-worksheet",
		title: "Patterns of Problematic Thinking Worksheet for CPT | Qwoach",
		metaDescription: "Explore the Cognitive Processing Therapy (CPT) Patterns of Problematic Thinking Worksheet. Record thoughts, consider thinking patterns, and review a descriptive profile.",
		h1: "Patterns of Problematic Thinking Worksheet for Cognitive Processing Therapy (CPT)",
		intro: "Record thoughts and stuck points, consider which thinking patterns fit, and review the recurring patterns with a practitioner. Categories can be adapted before sharing.",
		demoTitle: "Record and review thinking patterns",
		demoPrompt: "Add a thought, consider one or more patterns, and review the profile.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Collect distinct thoughts", body: "Each entry keeps the thought, its context, and its effect together. A thought can remain uncategorized or uncertain."},
			{title: "Review patterns", body: "The profile groups thoughts by selected pattern and distinguishes suggestions from practitioner-reviewed placements. Counts describe examples; they are not clinical scores."},
			{title: "Adapt the worksheet", body: "Practitioners can edit instructions, questions, pattern labels, explanations, order, and categorization mode."},
		],
		faqItems: [
			{question: "Can one thought fit more than one pattern?", answer: "Yes. Multiple patterns can be suggested and the practitioner can review the placement."},
			{question: "Must every pattern have an entry?", answer: "No. Empty patterns remain visible without creating a score or a missing-answer requirement."},
		],
	},
	{
		toolType: "presentTriggerWorksheet",
		slug: "present-trigger-worksheet",
		title: "Present Trigger Worksheet for EMDR | Qwoach",
		metaDescription: "Describe one current triggering situation, related responses, and practitioner review notes for EMDR target definition.",
		h1: "Present Trigger Worksheet for Current EMDR Triggers",
		intro: "Capture one present triggering situation and the responses linked to it. Practitioner and client can complete the worksheet together, then review whether the information needs clarification before EMDR work.",
		demoTitle: "Map a present trigger",
		demoPrompt: "Describe a current situation, review the recorded responses, and adapt the questions in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "One trigger per worksheet", body: "List situations that cause activation, then select one current situation to describe in detail. Start another worksheet for a different trigger."},
			{title: "Responses in context", body: "Record the picture or situation, beliefs, emotions, disturbance, and body sensation as reported. The practitioner decides whether more detail is needed."},
			{title: "Adapt the worksheet", body: "Edit question wording, sections, answer controls, rating ranges, and review labels before sharing the tool."},
		],
		faqItems: [
			{question: "Can the worksheet identify earlier memories?", answer: "It records the present trigger and associated responses. The practitioner decides how to use that information in EMDR work."},
			{question: "Can I change the questions?", answer: "Yes. The initial worksheet is editable in practitioner settings."},
			{question: "What if a response is unclear?", answer: "Leave it unanswered or add a clarification note during practitioner review."},
		],
	},
	{
		toolType: "impactStatement",
		slug: "impact-statement",
		title: "Impact Statement for Cognitive Processing Therapy (CPT) | Qwoach",
		metaDescription: "Assign and review a CPT Impact Statement with client draft saving, practitioner theme notes, and a preserved baseline.",
		h1: "Impact Statement for Cognitive Processing Therapy (CPT)",
		intro: "The Impact Statement helps clients beginning CPT write their current beliefs about a traumatic event and its effects. Practitioners review the statement, identify themes, and preserve it for later discussion.",
		demoTitle: "Write and review an Impact Statement",
		demoPrompt: "Read the assignment, write a statement, and record a practitioner theme in the review.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Client-authored baseline", body: "The client writes their own understanding of the event's cause and how it has affected beliefs about self, others, and the world."},
			{title: "Practitioner review", body: "The practitioner reads the original statement and adds private theme notes. The tool does not score the statement or identify themes automatically."},
			{title: "Revisit later", body: "A later statement can be assigned separately. Both submissions remain available for a human comparison of beliefs over time."},
		],
		faqItems: [
			{question: "Can the client save a draft?", answer: "Yes. On an assigned link, writing is saved for the client to resume before submission."},
			{question: "Does the tool score the statement?", answer: "No. The practitioner reviews the client's words and identifies treatment themes."},
		],
	},
	{
		toolType: "obsessiveCompulsiveInventoryChildVersionOciCv",
		slug: "obsessive-compulsive-inventory-child-version-oci-cv",
		title: "Obsessive-Compulsive Inventory – Child Version (OCI-CV) | Qwoach",
		metaDescription: "Explore the OCI-CV youth OCD self-report, 21 last-month ratings, total and domain scores, and practitioner review.",
		h1: "Obsessive-Compulsive Inventory – Child Version (OCI-CV)",
		intro: "The OCI-CV gathers a child or adolescent's ratings of obsessive-compulsive experiences during the last month. Practitioners review the youth-reported total, six symptom domains, and individual answers alongside other assessment information.",
		demoTitle: "Explore the youth self-report",
		demoPrompt: "Rate the statements, review the results, and adapt the questions or scoring in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Youth self-report", body: "The original template has 21 statements with Never, Sometimes, and Always ratings. A practitioner can edit the reusable wording and scoring before assigning the form."},
			{title: "Descriptive scoring", body: "Complete ratings produce a total and six domain sums. Unanswered items remain visible, and affected scores are withheld."},
			{title: "Practitioner review", body: "The result keeps the youth-reported source clear. The practitioner considers it with caregiver information and clinical assessment."},
		],
		faqItems: [
			{question: "Who completes the OCI-CV?", answer: "A child or adolescent rates their own experiences, with support from a practitioner when needed."},
			{question: "What period does it cover?", answer: "The default instructions ask about the last month."},
			{question: "Does it diagnose OCD?", answer: "No. The scores describe reported experiences for practitioner review."},
		],
	},
	{
		toolType: "statementOfPositionMap",
		slug: "statement-of-position-map",
		title: "Statement of Position Map for Narrative Therapy | Qwoach",
		metaDescription: "Help clients name a problem, explore its effects, evaluate those effects, and explain their position.",
		h1: "Statement of Position Map for narrative therapy",
		intro: "Clarify a client's own stance toward a problem through four inquiries: naming, effects, evaluation, and reasons. The map can remain partial.",
		demoTitle: "Map a position",
		demoPrompt: "Edit the client's wording, review the partial position, and adapt the questions in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Client-owned wording", body: "The client describes the problem and its effects, evaluates those effects, and names the values behind that position."},
			{title: "Open questions", body: "The map keeps unanswered questions visible without generating a score or advice."},
			{title: "Practitioner review", body: "Review the four parts together and revisit earlier positions to notice how the client's language changes."},
		],
		faqItems: [
			{question: "Can the position remain incomplete?", answer: "Yes. A partial map shows which questions are still open."},
			{question: "Does the map tell the client what to do?", answer: "No. It records the client's evaluation and reasons in their own words."},
		],
	},
	{
		toolType: "timeline", slug: "timeline",
		title: "Family Planning Timeline | Qwoach",
		metaDescription: "Build a shared chronology of placements, contacts, separations, and relationship changes for family-led planning.",
		h1: "Family Planning Timeline for shared chronology",
		intro: "Place major family, case, and relationship events in order. Record approximate timing and uncertain accounts to guide planning conversations.",
		demoTitle: "Build and review a timeline",
		demoPrompt: "Add an event, mark uncertain timing, then adapt categories in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Put events in context", body: "Record placements, contacts, separations, and relationship changes with exact dates or approximate periods."},
			{title: "Discuss uncertainty", body: "Keep differing accounts and follow-up needs visible so the chronology can be corrected together."},
			{title: "Adapt the template", body: "Change event prompts and category options before sharing with a family participant."},
		],
		faqItems: [
			{question: "Does every event need an exact date?", answer: "No. Use a year, approximate period, or relative order when the date is unknown."},
			{question: "Can a family participant correct an event?", answer: "Yes. They can edit event details and add context in the shared timeline."},
		],
	},
	{
		toolType: "selfMonitoringForm",
		slug: "self-monitoring-form",
		title: "OCD Self-Monitoring Form for Exposure and Response Prevention | Qwoach",
		metaDescription: "Record OCD episodes by trigger, SUDS rating, ritual description, and minutes spent ritualizing for exposure and response prevention planning.",
		h1: "OCD Self-Monitoring Form for Exposure and Response Prevention (ERP)",
		intro: "Record each OCD episode with its triggering situation or thought, distress level, overt or mental ritual, and time spent ritualizing. Practitioners use the log to choose exposure and response-prevention targets.",
		demoTitle: "Record and review episodes",
		demoPrompt: "Add an episode, review the reported time, and adapt the monitoring fields in settings.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Episode-by-episode record", body: "The client records a date and time, triggering situation, SUDS rating, ritual, and minutes spent. Mental rituals can be described alongside overt rituals."},
			{title: "Descriptive review", body: "Review the chronological entries, partial rows, episode count, and reported ritual minutes. The practitioner chooses treatment targets."},
			{title: "Adapt the form", body: "Change instructions, monitoring dates, labels, rating scale, and episode fields before sharing the tool."},
		],
		faqItems: [
			{question: "What if a trigger is unclear?", answer: "The client can enter “Unclear” and still record the other details."},
			{question: "Can the form record mental rituals?", answer: "Yes. The ritual description accepts overt or mental behaviors."},
			{question: "Does it rank ERP targets?", answer: "No. It displays reported intensity and time; the practitioner selects targets."},
		],
	},
	{
		toolType: "careerConstructionInterviewCci",
		slug: "career-construction-interview-cci",
		title: "Career Construction Interview (CCI) Demo | Qwoach",
		metaDescription: "Explore the Career Construction Interview for narrative career counseling, client stories, source-linked themes, and a practitioner-authored life-career portrait.",
		h1: "Career Construction Interview (CCI) for narrative career counseling",
		intro: "The Career Construction Interview gathers a client's career concern and life stories through a defined sequence. Counselors use the narrative to develop source-grounded themes and discuss meaningful next steps.",
		demoTitle: "Explore a CCI interview",
		demoPrompt: "Move through the prompts, enter a story, and review how a counselor connects themes to the original responses.",
		ctaText: "Save and get shareable link",
		sections: [
			{title: "Narrative first", body: "The opening question, five topics, and three early recollections help gather the client's own words before interpretation."},
			{title: "Theme grounding", body: "Counselors can link a confirmed theme to the responses that support it and write a life-career portrait for dialogue."},
			{title: "Use in counseling", body: "The interview supports career identity discussion. It does not produce scores, personality types, or occupation recommendations."},
		],
		faqItems: [
			{question: "Can an interview be incomplete?", answer: "Yes. Unanswered prompts remain visible, and the counselor can work with the narrative available."},
			{question: "Does CCI produce scores?", answer: "No. It collects stories and supports practitioner-confirmed interpretation."},
			{question: "Can counselor and client complete it together?", answer: "Yes. The counselor can guide the interview and enter the client's responses."},
		],
	},
	{
		toolType: "childObsessiveCompulsiveImpactScaleRevisedCoisR",
		slug: "cois-r-pediatric-ocd-impairment",
		title: "Child Obsessive-Compulsive Impact Scale-Revised (COIS-R) Demo | Qwoach",
		metaDescription: "Explore COIS-R parent and child reports of OCD-related functional impairment, with dated totals and follow-up review.",
		h1: "Child Obsessive-Compulsive Impact Scale-Revised (COIS-R)",
		intro: "COIS-R collects parent and child ratings of how obsessive compulsive symptoms affect everyday functioning during the past month. Practitioners can review each perspective and monitor reported impairment over time.",
		demoTitle: "Explore parent and child COIS-R forms",
		demoPrompt: "Switch between reporter forms, try the 0–3 ratings, and review separate totals. ",
		ctaText: "Save this questionnaire",
		sections: [
			{title: "Reporter-specific forms", body: "The parent and child forms have distinct questions. Select either form or both in settings."},
			{title: "Functional impairment", body: "The questionnaire asks about trouble caused by OCD at school, with others, and in everyday activities. It does not measure symptom severity."},
			{title: "Follow-up", body: "Dated results support comparison of totals from the same reporter form. Domain values remain unavailable until a verified scoring key is supplied."},
		],
		faqItems: [
			{question: "Can I use only the parent form?", answer: "Yes. Select parent, child, or both forms in settings."},
			{question: "What if parent and child ratings differ?", answer: "Their responses and totals remain separately labeled. The tool does not explain the difference automatically."},
			{question: "Is COIS-R a symptom severity scale?", answer: "No. It records OCD-related functional impairment."},
		],
	},
	{
		toolType: "childrenSYaleBrownObsessiveCompulsiveScaleSecondEditionCyBocsIi",
		isStaticPlaceholder: true,
		slug: "cy-bocs-ii-pediatric-ocd-assessment",
		title: "CY-BOCS-II Pediatric OCD Assessment Demo | Qwoach",
		metaDescription: "Explore the Children's Yale-Brown Obsessive-Compulsive Scale Second Edition clinician-rated pediatric OCD checklist, 0–5 ratings, and follow-up scores.",
		h1: "Children's Yale-Brown Obsessive-Compulsive Scale Second Edition (CY-BOCS-II)",
		intro: "CY-BOCS-II is a revised clinician-rated pediatric OCD assessment. Clinicians review child and caregiver information, mark current and past symptoms, and rate obsession and compulsion severity on ten 0–5 items.",
		demoTitle: "Request access to this assessment",
		demoPrompt: "Interested in using this assessment? Request access and we’ll email you about availability.",
		ctaText: "Request access",
		workTabLabel: "Clinician Interview",
		workTabDescription: "The clinician records child and caregiver information and makes the final consensus ratings. Children and caregivers do not score this form independently.",
		resultTabDescription: "Review the symptom profile, clinician ratings, and calculated obsession, compulsion, and total scores.",
		sections: [
			{title: "Clinician-rated use", body: "The revised checklist covers 66 obsessions, compulsions, and avoidance examples. Child and caregiver reports inform the clinician's judgment."},
			{title: "Monitoring over time", body: "Baseline and follow-up CY-BOCS-II results show dated score changes. The original CY-BOCS remains a separately labeled instrument."},
			{title: "What the result includes", body: "Results show current and past symptoms, item ratings, two subtotals, and a total when all ten clinician ratings are present. The tool does not generate a diagnosis or treatment plan."},
		],
		faqItems: [
			{question: "Is CY-BOCS-II the same as CY-BOCS?", answer: "No. This second edition has a revised symptom checklist and six response options per severity item."},
			{question: "Who creates the scores?", answer: "The clinician enters consensus ratings, and Qwoach sums the five obsession items, five compulsion items, and all ten items."},
			{question: "Can youth or parents complete it independently?", answer: "No. Their interview information supports clinician administration and ratings."},
		],
	},
	{
		toolType: "childrenSYaleBrownObsessiveCompulsiveScaleCyBocs",
		isStaticPlaceholder: true,
		slug: "children-s-yale-brown-obsessive-compulsive-scale-cy-bocs",
		title: "CY-BOCS Pediatric OCD Assessment Demo | Qwoach",
		metaDescription: "Explore the clinician-rated Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS) checklist, ten ratings, and obsession, compulsion, and total scores.",
		h1: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
		intro: "The CY-BOCS is a clinician-rated pediatric OCD assessment for children and adolescents. Clinicians review current and past symptoms with child and parent information, then rate obsession and compulsion severity.",
		demoTitle: "Request access to this assessment",
		demoPrompt: "Interested in using this assessment? Request access and we’ll email you about availability.",
		ctaText: "Request access",
		workTabLabel: "Clinician Interview",
		workTabDescription: "The clinician records child and parent information and enters the standardized ratings. This is a clinician-administered tool, not a child self-report form.",
		resultTabDescription: "This is how the clinician reviews checklist information, item ratings, and calculated scores before using the assessment in care.",
		sections: [
			{title: "Clinician-rated use", body: "Child and parent reports inform the interview. The clinician makes the final ratings and controls completion."},
			{title: "Monitoring over time", body: "Dated baseline and follow-up results can be reviewed together, with instrument identity preserved."},
			{title: "What the result includes", body: "Results show current and past symptom profiles, item ratings, obsession and compulsion subtotals, and a total when all required ratings are complete. The tool does not generate a diagnosis or treatment plan."},
		],
		faqItems: [
			{question: "Is CY-BOCS completed by the child alone?", answer: "No. This configuration is clinician-rated. The child and parent or guardian provide interview information."},
			{question: "What scores are shown?", answer: "The result shows obsession severity, compulsion severity, and total severity scores when required ratings are complete."},
			{question: "Can CY-BOCS be used for follow-up monitoring?", answer: "Yes. A follow-up uses the same scoring and can be compared with dated prior administrations."},
		],
	},
	{
		toolType: "readinessRuler",
		slug: "readiness-ruler",
		title: "Readiness Ruler for Change Motivation | Qwoach",
		metaDescription: "Try a readiness ruler demo for exploring motivation, confidence, and next steps before using it with coaching or therapy clients.",
		h1: "Readiness Ruler for Change Motivation",
		intro: "A readiness ruler helps clients name a change goal, rate how important it feels, and identify what would make the next step easier.",
		demoTitle: "Try the readiness ruler demo",
		demoPrompt: "Enter a change goal, adjust the ratings, and see the kind of response a practitioner can review.",
		sections: [
			{
				title: "What this tool helps with",
				body: "Use it when a client is considering a behavior change and needs a simple way to compare importance, confidence, and readiness.",
			},
			{
				title: "How practitioners use it",
				body: "Practitioners can adapt the wording, share the tool with a client, and use the response to guide motivational interviewing or coaching next steps.",
			},
			{
				title: "When not to use it",
				body: "Do not use it as a diagnosis or as a substitute for clinical judgement, crisis support, or a full risk assessment.",
			},
		],
		faqItems: [
			{
				question: "What is a readiness ruler?",
				answer: "It is a short scaling exercise that asks how important, confident, and ready someone feels about a specific change.",
			},
			{
				question: "Can therapists customize it?",
				answer: "Yes. In Qwoach, practitioners can save the tool and adjust the prompts before sharing it with clients.",
			},
		],
	},
	{
		toolType: "wheelOfLife",
		slug: "wheel-of-life",
		demoImplementation: "standaloneWheelOfLife",
		title: "Interactive Wheel of Life Assessment | Qwoach",
		metaDescription: "Try a Wheel of Life demo for reviewing balance, satisfaction, and coaching priorities across key life areas.",
		h1: "Interactive Wheel of Life Assessment",
		intro: "The Wheel of Life helps clients rate satisfaction across life areas and turn the pattern into practical coaching priorities.",
		demoTitle: "Try the Wheel of Life demo",
		demoPrompt: "Adjust the life-area ratings to preview how the tool highlights stronger and weaker domains.",
		sections: [
			{
				title: "What this tool helps with",
				body: "Use it to make life balance visible across health, relationships, work, growth, recreation, and environment.",
			},
			{
				title: "How practitioners use it",
				body: "Practitioners can adjust the life areas, collect client ratings, and compare changes across sessions.",
			},
			{
				title: "When not to use it",
				body: "Do not treat the wheel as a validated clinical measurement or a replacement for a structured assessment.",
			},
		],
		faqItems: [
			{
				question: "What is the Wheel of Life?",
				answer: "It is a coaching reflection tool that maps satisfaction or balance across multiple life domains.",
			},
			{
				question: "Can the areas be changed?",
				answer: "Yes. Practitioners can customize the areas after saving the tool to their Qwoach workspace.",
			},
		],
	},
	{
		toolType: "valuesBullseye",
		slug: "values-bullseye",
		title: "Values Bullseye ACT Tool Demo | Qwoach",
		metaDescription: "Try a Values Bullseye demo for exploring value alignment and committed action in coaching or therapy.",
		h1: "Values Bullseye for ACT Value Alignment",
		intro: "The Values Bullseye helps clients map how closely current actions line up with important values.",
		demoTitle: "Try the Values Bullseye demo",
		demoPrompt: "Adjust the value-area ratings to preview how current actions can be mapped against chosen values.",
		sections: [
			{
				title: "What this tool helps with",
				body: "Use it to clarify values, notice gaps between intentions and actions, and choose a committed next step.",
			},
			{
				title: "How practitioners use it",
				body: "Practitioners can customize value areas, share the tool, and review client responses as part of ACT-informed work.",
			},
			{
				title: "When not to use it",
				body: "Do not use it to score morality, diagnose symptoms, or pressure a client toward values they did not choose.",
			},
		],
		faqItems: [
			{
				question: "What is a Values Bullseye?",
				answer: "It is a visual reflection tool that shows how closely behavior aligns with selected values.",
			},
			{
				question: "Is this an ACT tool?",
				answer: "It is commonly used in ACT-informed work, but practitioners should apply it within their own professional scope.",
			},
		],
	},
	{
		toolType: "moodDiary",
		slug: "mood-diary",
		tags: {toolType: ["Diary card"], workflow: ["Between-session monitoring", "Progress review"], topic: ["Emotion regulation"]},
		title: "Mood Diary Tool Demo for Therapy and Coaching | Qwoach",
		metaDescription: "Try a mood diary demo for tracking mood, context, activities, and patterns between therapy or coaching sessions.",
		h1: "Mood Diary for Tracking Patterns Between Sessions",
		intro: "A mood diary helps clients record mood, context, and activity so patterns can be reviewed later with a practitioner.",
		demoTitle: "Try the mood diary demo",
		demoPrompt: "Create a mood entry with a rating, emotion word, context, and activity notes.",
		sections: [
			{
				title: "What this tool helps with",
				body: "Use it to notice emotional patterns, triggers, protective factors, and changes across repeated entries.",
			},
			{
				title: "How practitioners use it",
				body: "Practitioners can share a diary prompt, review entries, and use trends to focus session planning.",
			},
			{
				title: "When not to use it",
				body: "Do not use it as a crisis tool or as a substitute for immediate support when safety concerns are present.",
			},
		],
		faqItems: [
			{
				question: "What should a mood diary include?",
				answer: "A useful mood diary usually includes a mood rating, emotion words, context, activity, and notes about what happened next.",
			},
			{
				question: "Can clients complete it between sessions?",
				answer: "Yes. Qwoach tools are designed so practitioners can share structured work with clients outside the session.",
			},
		],
	},
	{
		toolType: "dbtSkillsDiaryCard",
		slug: "dbt-skills-diary-card",
		title: "Dialectical Behavior Therapy (DBT) Skills Diary Card for Weekly Monitoring | Qwoach",
		metaDescription: "Explore a Dialectical Behavior Therapy (DBT) Skills Diary Card for daily urges, emotions, target behaviors, medication/substance context, skills practice, and therapist review.",
		h1: "Dialectical Behavior Therapy (DBT) Skills Diary Card",
		intro: "The Dialectical Behavior Therapy (DBT) Skills Diary Card is a weekly self-monitoring tool for practitioners and clients. It helps therapists review daily urges, emotions, target behaviors, medication or substance context, and skills practice before setting session priorities.",
		demoTitle: "See a weekly Dialectical Behavior Therapy (DBT) diary card before you assign it",
		demoPrompt: "Configure target behaviors and context fields, enter data, then review the weekly grid.",
		initialTab: "client",
		sections: [
			{
				title: "What this tool is for",
				body: "Use it when a Dialectical Behavior Therapy (DBT) therapist needs reliable between-session information instead of relying only on in-session recall.",
			},
			{
				title: "What it captures",
				body: "The card captures daily reported ratings, target behavior occurrences, skills practiced, relevant medication/substance context, and notes where enabled.",
			},
			{
				title: "Longitudinal review",
				body: "Submitted weeks remain available for comparison over time, with configuration differences visible when targets or context fields change.",
			},
		],
		faqItems: [
			{
				question: "Does the Dialectical Behavior Therapy (DBT) Skills Diary Card generate session priorities?",
				answer: "No. It organizes reported diary-card data so the therapist can identify likely priorities or chain-analysis targets.",
			},
			{
				question: "Can clients leave days incomplete?",
				answer: "Yes. Missing or partial days remain visible instead of forcing fabricated answers.",
			},
			{
				question: "What can I configure?",
				answer: "You can configure target behaviors, medication/substance fields, skills checklist items, and optional notes or session-entry ratings.",
			},
			{
				question: "Are demo responses saved as client data?",
				answer: "No. Entries and review notes are for public exploration only and are not saved as real client data.",
			},
		],
	},
	{
		toolType: "nidaDiaryCard",
		slug: "dbt-substance-use-diary-card",
		title: "Dialectical Behavior Therapy (DBT) Substance Use Diary Card for Weekly Monitoring | Qwoach",
		metaDescription: "Explore an original Dialectical Behavior Therapy (DBT) substance-use diary-card preset for daily substance-use, medication, risk-behavior, urge, emotion, reinforcement, and skills review.",
		h1: "Dialectical Behavior Therapy (DBT) Substance Use Diary Card",
		intro: "This original Dialectical Behavior Therapy (DBT) substance-use diary-card preset is for practitioners working with substance-use, medication or pharmacotherapy adherence, HIV-risk behavior, and related target behaviors. For practitioners familiar with NIDA Diary Card-style monitoring, it focuses on day-by-day substance use, medication context, urges, risk behavior, reinforcement, and skills practice.",
		demoTitle: "Review a weekly Dialectical Behavior Therapy (DBT) substance-use diary-card preset",
		demoPrompt: "Choose applicable substance-use and medication rows, compare blank and zero/none entries, then review the weekly pattern.",
		sections: [
			{
				title: "What this tool is for",
				body: "Use this tool when Dialectical Behavior Therapy (DBT) treatment needs daily monitoring of substance use, medication or pharmacotherapy adherence, HIV-risk behavior, self-harm or related behaviors, urges, emotions, reinforcement, and skills use.",
			},
			{
				title: "Blank versus none",
				body: "The card distinguishes unanswered fields from reported zero or none so review does not confuse missing data with no occurrence.",
			},
			{
				title: "What the practitioner gets",
				body: "The practitioner gets a completed or partial weekly card with daily descriptive data and private review notes for session prioritization or chain-analysis planning.",
			},
			{
				title: "A practical Dialectical Behavior Therapy (DBT) diary-card alternative",
				body: "Practitioners searching for a NIDA Diary Card often use this type of Dialectical Behavior Therapy (DBT) substance-use diary card to track daily substance use, medication context, urges, risk behavior, reinforcement, and skills practice.",
			},
		],
		faqItems: [
			{
				question: "Can I use this instead of a NIDA Diary Card?",
				answer: "This Qwoach Dialectical Behavior Therapy (DBT) substance-use diary card supports similar daily tracking needs: substance use, urges, medication context, risk behavior, reinforcement, and skills practice.",
			},
			{
				question: "Is this diary card a medication manager?",
				answer: "No. It records medication and pharmacotherapy context for Dialectical Behavior Therapy (DBT) review but does not provide medication guidance.",
			},
			{
				question: "Can the demo include substance-use examples without real client data?",
				answer: "Yes. You can explore the diary before saving your own configuration.",
			},
			{
				question: "What happens if a client leaves a field blank?",
				answer: "Blank fields remain visible as missing rather than being treated as zero or none.",
			},
			{
				question: "Does the tool decide risk level or treatment actions?",
				answer: "No. It organizes diary-card data for practitioner review and does not generate clinical conclusions.",
			},
		],
	},
	{
		toolType: "valuesCardSort",
		slug: "values-card-sort",
		title: "Values Exercise Tool Demo | Qwoach",
		metaDescription: "Try a Values Exercise demo for helping clients clarify priorities, compare values, and discuss what matters most.",
		h1: "Values Exercise for Priority Clarification",
		intro: "A values exercise helps clients narrow value words into a short list so they can see what matters most right now.",
		demoTitle: "Try the values exercise demo",
		demoPrompt: "Select value cards across narrowing steps to preview how the tool structures values clarification.",
		sections: [
			{
				title: "What this tool helps with",
				body: "Use it when a client needs a concrete way to compare values, name priorities, and notice what feels more or less important.",
			},
			{
				title: "How practitioners use it",
				body: "Practitioners can customize the cards and step counts, share the exercise with clients, and review which values emerge as current priorities.",
			},
			{
				title: "When not to use it",
				body: "Do not use it to prescribe values, rank morality, or pressure a client toward priorities they did not choose.",
			},
		],
		faqItems: [
			{
				question: "What is a values card sort?",
				answer: "It is a values clarification exercise where a client sorts value cards into groups such as very important, important, and not important.",
			},
			{
				question: "Can practitioners customize the cards?",
				answer: "Yes. Practitioners can edit the value cards and sorting groups before sharing the tool with clients.",
			},
		],
	},
	{
		toolType: "dbtChainAnalysis",
		slug: "dbt-chain-analysis-worksheet",
		title: "Dialectical Behavior Therapy (DBT) Chain Analysis Worksheet | Qwoach",
		metaDescription: "Explore a Dialectical Behavior Therapy (DBT) chain analysis worksheet for reconstructing one problem behavior through prompting event, vulnerabilities, links, consequences, and alternatives.",
		h1: "Dialectical Behavior Therapy (DBT) Chain Analysis Worksheet",
		intro: "The Dialectical Behavior Therapy (DBT) Chain Analysis Worksheet helps practitioners and clients reconstruct one target problem behavior by mapping the prompting event, vulnerability factors, ordered links, consequences, and possible alternatives.",
		demoTitle: "Build a chain",
		demoPrompt: "Name one concrete behavior, add a few links, and add a possible alternative to one item.",
		sections: [
			{
				title: "What this tool is for",
				body: "Use this worksheet preset after a Dialectical Behavior Therapy (DBT) client has engaged in a target problem behavior and practitioner and client need a shared functional understanding of what led to it and what followed.",
			},
			{
				title: "One behavior at a time",
				body: "The worksheet is anchored to one concrete target behavior. If multiple behaviors appear in the same incident, select one behavior first.",
			},
			{
				title: "Partial chains",
				body: "Uncertain or missing links can remain unresolved. The result preserves completed sections without forcing unsupported detail.",
			},
			{
				title: "Natural continuation",
				body: "A completed chain can lead into solution analysis, possible alternatives, follow-up planning, or future diary-card monitoring.",
			},
		],
		faqItems: [
			{
				question: "Does this worksheet choose Dialectical Behavior Therapy (DBT) skills for the client?",
				answer: "No. It organizes the chain and attached alternatives, but it does not automatically select skills or make treatment recommendations.",
			},
			{
				question: "Can the chain be incomplete?",
				answer: "Yes. Partial chains remain visible with unresolved sections for later work.",
			},
			{
				question: "Can the chain be edited?",
				answer: "Yes. Items can be added, edited, or removed as the sequence becomes clearer.",
			},
			{
				question: "What is saved if there are no settings?",
				answer: "The Chain Analysis worksheet preset is saved; demo content is not saved as real client data.",
			},
		],
	},
	{
		toolType: "dbtSolutionAnalysis",
		slug: "dbt-solution-analysis",
		title: "Dialectical Behavior Therapy (DBT) Solution Analysis for Chain-Linked Planning | Qwoach",
		metaDescription: "Explore Dialectical Behavior Therapy (DBT) Solution Analysis for linking behavior-chain points to alternatives, prevention steps, environmental changes, practice, and repair actions.",
		h1: "Dialectical Behavior Therapy (DBT) Solution Analysis",
		intro: "Dialectical Behavior Therapy (DBT) Solution Analysis helps practitioners and clients turn a behavior chain into linked next steps by connecting specific chain points to alternatives, prevention steps, environmental changes, practice commitments, and repair actions.",
		demoTitle: "Map solutions",
		demoPrompt: "Review the chain points, then add solutions only under the sections you want to work on.",
		ctaText: "Save this tool",
		sections: [
			{
				title: "What this tool is for",
				body: "Use it after or during Dialectical Behavior Therapy chain analysis when practitioner and client need to decide what could happen differently at specific points in the behavior pathway.",
			},
			{
				title: "Depends on chain context",
				body: "The tool starts from chain elements and records solutions where the practitioner and client want to work on a different response. If no completed chain exists, chain elements can be entered manually.",
			},
			{
				title: "Specific linked actions",
				body: "Solution entries stay in the same section as the chain point, consequence, or harm area so the plan remains tied to the behavior pathway rather than becoming a generic goal list.",
			},
			{
				title: "Partial plans",
				body: "Sections can be left blank when they are not the focus for this plan, instead of forcing premature agreement.",
			},
		],
		faqItems: [
			{
				question: "Does Dialectical Behavior Therapy (DBT) Solution Analysis generate Dialectical Behavior Therapy (DBT) skills?",
				answer: "No. It records practitioner-client agreed solutions and does not generate skills or prescribe actions.",
			},
			{
				question: "Can it be used without a completed chain analysis?",
				answer: "Yes. Chain elements may be entered manually when the completed chain lives outside Qwoach or is still being reconstructed.",
			},
			{
				question: "What counts as a solution entry?",
				answer: "A solution entry can be a prevention step, skillful alternative, environmental or contingency change, rehearsal or practice commitment, or repair action tied to a chain point.",
			},
			{
				question: "Is planning content saved?",
				answer: "No. The fixed tool is saved, while chain and solution entries from the demo are discarded.",
			},
		],
	},
	{
		toolType: "missingLinksAnalysis",
		slug: "missing-links-analysis",
		title: "Dialectical Behavior Therapy (DBT) Missing-Links Analysis Worksheet Demo | Qwoach",
		metaDescription: "Explore Missing-Links Analysis, a Dialectical Behavior Therapy (DBT) worksheet for identifying what blocked an expected effective behavior and planning a fitting correction.",
		h1: "Dialectical Behavior Therapy (DBT) Missing-Links Analysis",
		intro: "Dialectical Behavior Therapy (DBT) Missing-Links Analysis helps practitioners and clients review why an expected, agreed, hoped-for, or needed effective behavior did not occur, then connect the likely barrier to a practical next plan.",
		demoTitle: "Review a missing-links worksheet",
		demoPrompt: "Walk through one missed effective behavior, then add next supports only where they are useful.",
		ctaText: "Save this tool",
		sections: [
			{
				title: "What this tool is for",
				body: "Use this tool when the clinical question is why an effective behavior did not happen. The worksheet keeps attention on knowledge, willingness, remembering, prompting, follow-through, and other obstacles.",
			},
			{
				title: "Partial analysis is allowed",
				body: "If the answer is unclear, the worksheet can keep that checkpoint open instead of forcing a premature barrier category.",
			},
			{
				title: "Plan stays tied to the barrier",
				body: "Next supports are recorded beside the checkpoint they address, so the plan stays connected to what got in the way.",
			},
		],
		faqItems: [
			{
				question: "Is Missing-Links Analysis the same as Chain Analysis?",
				answer: "No. Missing-Links Analysis is for an expected effective behavior that did not occur; Chain Analysis is for understanding a problem behavior that occurred.",
			},
			{
				question: "Does the tool decide the corrective step?",
				answer: "No. It organizes the review and records the practitioner-client plan.",
			},
			{
				question: "Can the analysis stay partial?",
				answer: "Yes. Partial work preserves unresolved checkpoints for later review.",
			},
		],
	},
	{
		toolType: "linehanRiskAssessmentAndManagementProtocolLramp",
		slug: "linehan-risk-assessment-and-management-protocol-lramp",
		title: "LRAMP Suicide and Self-Injury Risk Protocol Demo | Qwoach",
		metaDescription: "Explore LRAMP, a practitioner-only DBT protocol for documenting suicide/self-injury risk factors, protective factors, actions, disposition, and reevaluation.",
		h1: "Linehan Risk Assessment and Management Protocol (LRAMP)",
		intro: "The Linehan Risk Assessment and Management Protocol (LRAMP) is a practitioner-only DBT protocol for clinicians. It helps document suicide and self-injury risk formulation, acute risk factors, protective factors, management actions, disposition, clinical rationale, and reevaluation timing.",
		demoTitle: "Review a protocol",
		demoPrompt: "Edit a practitioner-only draft record, mark unknown information where needed, and review the structured documentation output.",
		ctaText: "Save this tool",
		workTabLabel: "Protocol Entry",
		workTabDescription: "This practitioner-only entry surface is where the clinician documents the protocol.",
		sections: [
			{
				title: "Practitioner-only use",
				body: "LRAMP has no separate client-facing product experience. Client information may be elicited during care, but the tool surface is clinician documentation.",
			},
			{
				title: "Completeness without automation",
				body: "The system can show incomplete sections and unresolved reevaluation timing, while practitioner judgment controls formulation, actions, disposition, and timing.",
			},
			{
				title: "Follow-up clarity",
				body: "Completed records remain available for reassessment. Later updates should preserve the prior documented state as follow-up or reevaluation entries.",
			},
		],
		faqItems: [
			{
				question: "Does LRAMP assign suicide risk level automatically?",
				answer: "No. LRAMP supports practitioner documentation and does not compute or assign risk levels unless entered by the clinician using supported fields.",
			},
			{
				question: "Is there a client-facing version of this tool?",
				answer: "No. LRAMP is practitioner-only; the client may provide information during assessment, but the product workflow is clinician-completed.",
			},
			{
				question: "Can incomplete information be recorded?",
				answer: "Yes. Unknown or not assessed information should be documented as such rather than inferred.",
			},
			{
				question: "What is saved from the demo?",
				answer: "The LRAMP tool configuration is saved; risk details and documentation are not saved as real client data.",
			},
		],
	},
	{
		toolType: "imminentRiskAndActionPlan",
		slug: "imminent-risk-and-action-plan-brtc-imminent-suicide-risk-and-treatment-actions-note",
		title: "Imminent Suicide Risk and Treatment Actions Note Demo | Qwoach",
		metaDescription: "Explore a practitioner-only imminent-risk action note for documenting suicide/self-injury risk concerns, actions, emergency decisions, and reevaluation timing.",
		h1: "Imminent Risk and Action Plan / BRTC Imminent Suicide Risk and Treatment Actions Note",
		intro: "The Imminent Risk and Action Plan is a practitioner-only Dialectical Behavior Therapy (DBT) treatment-actions note for clinicians. It helps document current or increased suicide/self-injury risk concern, risk and protective factors, treatment actions, emergency interventions considered or taken, consultation, follow-up responsibility, and reevaluation timing.",
		demoTitle: "Review a action note",
		demoPrompt: "Edit a urgent note, mark pending or unknown information, and review how missing reevaluation responsibility stays visible.",
		ctaText: "Save this tool",
		workTabLabel: "Note Entry",
		workTabDescription: "This practitioner-only entry surface is where the clinician documents the action note.",
		sections: [
			{
				title: "What this tool is for",
				body: "Use this tool when a Dialectical Behavior Therapy (DBT) clinician identifies current or increased suicidal ideation, suicide threat, suicide attempt, self-injury, or imminent suicide risk requiring immediate documentation and treatment response.",
			},
			{
				title: "Rapid partial completion",
				body: "The note supports fast capture when time-sensitive action happens before every section is complete, while keeping unresolved sections visible for follow-up.",
			},
			{
				title: "Reevaluation visibility",
				body: "Follow-up responsibility and reevaluation timing are central completion elements and remain prominent until entered.",
			},
			{
				title: "Documentation support only",
				body: "The tool records practitioner-entered concerns, actions, decisions, consultation, and follow-up timing. It does not determine imminent risk or prescribe emergency action.",
			},
		],
		faqItems: [
			{
				question: "Does this note determine imminent suicide risk?",
				answer: "No. It documents practitioner-entered concern, actions, decisions, and reevaluation timing; it does not automate risk determination.",
			},
			{
				question: "Is this the same as LRAMP?",
				answer: "No. This is a practitioner-only imminent-risk treatment-actions note; LRAMP is a broader risk assessment and management protocol.",
			},
			{
				question: "Can emergency action be documented before every section is complete?",
				answer: "Yes. The workflow supports rapid partial completion while showing unresolved sections.",
			},
			{
				question: "What is saved after demo exploration?",
				answer: "The tool configuration is saved; risk concerns and note data are not saved as real client data.",
			},
		],
	},
]

function mergeToolDemoPageDefinitions(generatedPages = generatedToolDemoPageDefinitions) {
	let bySlug = new Map()
	let curatedToolTypes = new Set()
	const generatedBySlug = new Map(generatedPages.map(page => [page.slug, page]))
	const generatedByType = new Map()
	generatedPages.forEach(page => {
		if (generatedByType.has(page.toolType)) throw new Error(`Duplicate generated tool type: ${page.toolType}`)
		generatedByType.set(page.toolType, page)
	})
	curatedToolDemoPageDefinitions.forEach(pageDefinition => {
		if (!isGeneratedToolDemoBlockedSlug(pageDefinition.slug)) {
			const spec = pageDefinition.tagSourceSlug ? generatedBySlug.get(pageDefinition.tagSourceSlug) : generatedByType.get(pageDefinition.toolType) || generatedBySlug.get(pageDefinition.slug)
			if (pageDefinition.tagSourceSlug && !spec) throw new Error(`Missing tag source for ${pageDefinition.slug}: ${pageDefinition.tagSourceSlug}`)
			bySlug.set(pageDefinition.slug, {...pageDefinition, tags: spec?.tags || pageDefinition.tags || {}, specId: pageDefinition.tagSourceSlug ? undefined : spec?.specId})
			curatedToolTypes.add(pageDefinition.toolType)
		}
	})
	generatedPages.forEach(pageDefinition => {
		if (!isGeneratedToolDemoBlockedSlug(pageDefinition.slug) && !bySlug.has(pageDefinition.slug) && !curatedToolTypes.has(pageDefinition.toolType)) {
			bySlug.set(pageDefinition.slug, pageDefinition)
		}
	})
	return Array.from(bySlug.values())
}

const toolDemoPageDefinitions = mergeToolDemoPageDefinitions()

function getAllToolDemoPageDefinitions() {
	return toolDemoPageDefinitions
}

function getToolDemoPageDefinitions() {
	return toolDemoPageDefinitions.map(pageDefinition => pageDefinition.isStaticPlaceholder || isToolAvailable(pageDefinition.toolType)
		? pageDefinition
		: {...pageDefinition, isStaticPlaceholder: true, demoTitle: "Request access to this tool", demoPrompt: "Interested in using this tool? Request access and we’ll email you about availability.", ctaText: "Request access"})
}

function getToolDemoPageDefinitionBySlug(slug) {
	return getToolDemoPageDefinitions().find(pageDefinition => pageDefinition.slug === slug) || null
}

function getToolDemoPageDefinitionByType(toolType) {
	return getToolDemoPageDefinitions().find(pageDefinition => pageDefinition.toolType === toolType) || null
}

exports.getAllToolDemoPageDefinitions = getAllToolDemoPageDefinitions
exports.mergeToolDemoPageDefinitions = mergeToolDemoPageDefinitions
exports.getToolDemoPageDefinitions = getToolDemoPageDefinitions
exports.getToolDemoPageDefinitionBySlug = getToolDemoPageDefinitionBySlug
exports.getToolDemoPageDefinitionByType = getToolDemoPageDefinitionByType
